import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Uncut Gems",
  date: new Date(2024, 2, 24),
  img: "/img/mixing.jpeg",
  video: "/videos/mixing.mp4",
  tracks: [
    {
      title: "New Beginnigs",
      src: "/songs/2024-03-25/new_beginnings.mp3",
      duration: 823.152,
    },
    {
      title: "Easy Does It",
      src: "/songs/2024-03-25/easy_does_it.mp3",
      duration: 243.912,
    },
    {
      title: "Gratitude",
      src: "/songs/2024-03-25/gratitude.mp3",
      duration: 484.44,
    },
    {
      title: "Alphanumerical Substitution",
      src: "/songs/2024-03-25/alphanumerical_substitution.mp3",
      duration: 750.576,
    },
    {
      title: "Heartfelt Expressions",
      src: "/songs/2024-03-25/heartfelt_expressions.mp3",
      duration: 614.256,
    },
    {
      title: "Heed The Call",
      src: "/songs/2024-03-25/heed_the_call.mp3",
      duration: 579,
    },
    {
      title: "Fair Trade",
      src: "/songs/2024-03-25/fair_trade.mp3",
      duration: 1568.328,
    },
    {
      title: "Covert Strut",
      src: "/songs/2024-03-25/covert_strut.mp3",
      duration: 726.72,
    },
    {
      title: "Pizza Party",
      src: "/songs/2024-03-25/pizza_party.mp3",
      duration: 341.52,
    },
    {
      title: "Balancing Act",
      src: "/songs/2024-03-25/balancing_act.mp3",
      duration: 1269.816,
    },
    {
      title: "Night Train",
      src: "/songs/2024-03-25/night_train.mp3",
      duration: 798.576,
    },
    {
      title: "Dances With Improv",
      src: "/songs/2024-03-25/dances_with_improv.mp3",
      duration: 1553.16,
    },
  ],
};
export default album;
